import React from 'react';

export default function Footer() {
  return (
    <footer style={{ background: '#080f1e', padding: '60px 5% 30px', color: 'rgba(255,255,255,0.55)' }}>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 60, marginBottom: 48 }} className="footer-grid">

        {/* Brand */}
        <div>
          
          <p style={{ fontSize: '0.87rem', lineHeight: 1.7, maxWidth: 280 }}>
            Your reliable partner for professional cleaning services across SE1 London. Trusted by homeowners, landlords and Airbnb hosts since 2020.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'Home',           href: '#hero' },
              { label: 'About Us',       href: '#about' },
              { label: 'Services',       href: '#services' },
              { label: 'Areas We Cover', href: '#areas' },
              { label: 'Gallery',        href: '#gallery' },
              { label: 'Reviews',        href: '#reviews' },
              { label: 'Contact',        href: '#contact' },
            ].map(({ label, href }) => (
              <li key={label}>
                <a href={href}
                  style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.88rem', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = 'var(--orange)'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Services</h4>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              'Airbnb Cleaning',
              'End of Tenancy',
              'Residential Cleaning',
              'One-Off Deep Clean',
            ].map(label => (
              <li key={label}>
                <a href="#services"
                  style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.88rem', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = 'var(--orange)'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Social Media + Contact */}
        <div>
          <h4 style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>Follow Us</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[
              { name: 'Facebook',  icon: '/icon/facebook.png',  url: 'https://facebook.com',       color: '#1877f2' },
              { name: 'Instagram', icon: '/icon/instagram (2).png', url: 'https://www.instagram.com/se1hostcarecleaning?igsh=MXcyYjYyeXZpbDBqZg==',      color: '#e1306c' },
              { name: 'WhatsApp',  icon: '/icon/whatsapp.png',  url: 'https://wa.me/447853481188', color: '#25d366' },
              { name: 'TikTok',    icon: '/icon/tik-tok.png',    url: 'https://www.tiktok.com/@se1.hostcare.clea',         color: '#ff0050' },
            ].map(({ name, icon, url, color }) => (
              <a key={name} href={url} target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', transition: 'opacity 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                <div style={{
                  width: 36, height: 36, borderRadius: 8,
                  background: `${color}22`,
                  border: `1px solid ${color}44`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <img src={icon} alt={name} style={{ width: 20, height: 20, objectFit: 'contain' }} />
                </div>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.88rem' }}>{name}</span>
              </a>
            ))}
          </div>

          {/* Quick contact */}
          <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <a href="tel:+447853481188"
              style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.82rem', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--orange)'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}>
              <img src="/icon/call.png" alt="phone" style={{ width: 16, height: 16, objectFit: 'contain' }} />
              07853 481188
            </a>
            <a href="mailto:se1hostcarecleaning@gmail.com"
              style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.82rem', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--orange)'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}>
              <img src="/icon/gmail.png" alt="email" style={{ width: 16, height: 16, objectFit: 'contain' }} />
              se1hostcarecleaning@gmail.com
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.07)',
        paddingTop: 28,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: 16, fontSize: '0.82rem',
      }}>
        <span>© 2026 SE1 HostCare Cleaning. All rights reserved.</span>
        <span>Made with love in London ·{' '}
          <a href="mailto:se1hostcarecleaning@gmail.com" style={{ color: 'var(--orange)', textDecoration: 'none' }}>
            se1hostcarecleaning@gmail.com
          </a>
        </span>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
        }
        @media (max-width: 480px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}